const dataTableButtonClick = {
  namespaced: true,
  state: () => ({
    isButtonClicked: false,
    clickedButtonProp: {
      clickedButton: '',
      data: null
    }
  }),

  getters: {
    getIsButtonClicked: state => state.isButtonClicked,
    getClickedButtonProp: state => state.clickedButtonProp
  },

  actions: {
    SetIsButtonClicked: ({ state }, data) => {
      state.isButtonClicked = data
    },
    SetClickedButtonProp: ({ state }, { clickedButton, data }) => {
      state.clickedButtonProp.clickedButton = clickedButton
      state.clickedButtonProp.data = data
    },
    ClearButtonProp: ({ dispatch }) => {
      // update button clicked state
      dispatch('SetIsButtonClicked', false)
      // update modal prop
      dispatch('SetClickedButtonProp', {
        clickedButton: '',
        data: null
      })
    }
  }
}

export default dataTableButtonClick
